export const PRODUCT_CLASSES = [
  'text',
  'multimedia',
  'picture',
  'graphic',
  'videography',
  'video',
  'webstory',
  'factcheck'
] as const

export type AfpClass = (typeof PRODUCT_CLASSES)[number]
